import { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Layout from "./components/layout/Layout";
import HomePage from "./pages/home/HomePage";
import SchoolPage from "./pages/school/SchoolPage";
import ProgramsPage from "./pages/programs/ProgramsPage";
import StudentLifePage from "./pages/student-life/StudentLifePage";
import ContactPage from "./pages/contact/ContactPage";
import StatusManager from "./components/StatusManager";
import SplashScreen from "./components/SplashScreen";

// ScrollToTop component to handle scrolling to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
};

function App() {
  const [showSplash, setShowSplash] = useState(true);

  const handleSplashFinish = () => {
    setShowSplash(false);
  };

  return (
    <Router>
      {showSplash ? (
        <SplashScreen onFinish={handleSplashFinish} />
      ) : (
        <>
          <ScrollToTop />
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/notre-ecole" element={<SchoolPage />} />
              <Route path="/nos-cycles" element={<ProgramsPage />} />
              <Route path="/vie-etudiante" element={<StudentLifePage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/status" element={<StatusManager />} />
            </Routes>
          </Layout>
        </>
      )}
    </Router>
  );
}

export default App;
